<template>
    <v-container>
      <h4 class="text-center mt-3">Colores</h4>
  
      <h5 class="text-center mt-5">Background</h5>
      <koiote-color-picker-vue
        class="mt-1"
        :pcolor="selectedItem.customized.background_color"
        @event="change_background_color"
      ></koiote-color-picker-vue>
  
      <h5 class="text-center mt-5">Foreground</h5>
      <koiote-color-picker-vue
        class="mt-1"
        :pcolor="selectedItem.customized.foreground_color"
        @event="change_foreground_color"
      ></koiote-color-picker-vue>
  
      <h5 class="text-center mt-5">Borde</h5>
      <koiote-color-picker-vue
        class="mt-1"
        :pcolor="selectedItem.customized.border_color"
        @event="change_border_color"
      ></koiote-color-picker-vue>
  
      <h4 class="text-center mt-7">Propiedades</h4>
      <v-text-field
        prefix="Unidades:"
        class="ml-3 mr-3 mb-5"
        v-model="selectedItem.customized.units"
        @click="updateEditing(true)"
      >
      </v-text-field>
  
      <v-text-field
        prefix="Título:"
        class="ml-3 mr-3 mb-5"
        v-model="selectedItem.customized.label"
        @click="updateEditing(true)"
      >
      </v-text-field>
  
      <v-text-field
        prefix="Tipo:"
        class="ml-3 mr-3 mb-5"
        v-model="selectedItem.customized.datatype"
        @click="updateEditing(true)"
      >
      </v-text-field>
  
      <v-label class="ml-3"> Valor actual: {{ value }} </v-label>
  
      <v-text-field
        prefix="Mínimo:"
        class="ml-3 mr-3 mt-6"
        v-model="selectedItem.customized.min_value"
        @click="updateEditing(true)"
      >
      </v-text-field>
  
      <v-text-field
        prefix="Máximo:"
        class="ml-3 mr-3 mt-4"
        v-model="selectedItem.customized.max_value"
        @click="updateEditing(true)"
      >
      </v-text-field>
  
          <!-- depuradoras-------------------------------------------------------- -->

    <v-text-field
        prefix="Auto/Manual:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.is_auto"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.write_topic_bomb == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />

      <v-text-field
        prefix="Consigna Manual:"
        class="ml-3 mr-3 mb-7"
        v-model="selectedItem.customized.address"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.address == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />

      <v-text-field
        prefix="Consigna Auto:"
        class="ml-3 mr-3 mb-7"
        v-model="selectedItem.customized.auto_address"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.address == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />

      <v-text-field
        prefix="Write topic:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.write_topic_bomb"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.write_topic_bomb == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />
      <v-text-field
        prefix="Limite caudal Y1:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.limite_caudal_Y1"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.limite_caudal_Y1 == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />
      <v-text-field
        prefix="Limite caudal Y2:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.limite_caudal_Y2"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.limite_caudal_Y2 == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />

      <v-text-field
        prefix="VEGA %:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.porcentaje_vega"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.porcentaje_vega == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />

      <v-text-field
        prefix="Limite VEGA X1:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.limite_volumen_vega_X1"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.limite_volumen_vega_X1 == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />
      <v-text-field
        prefix="Limite VEGA X2:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.limite_volumen_vega_X2"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.limite_volumen_vega_X2 == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />

      <v-text-field
        prefix="200K %:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.porcentaje_200"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.porcentaje_200 == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />

      <v-text-field
        prefix="Limite 200 X1:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.limite_volumen_200_X1"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.limite_volumen_200_X1 == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />
      <v-text-field
        prefix="Limite 200 X2:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.limite_volumen_200_X2"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.limite_volumen_200_X2 == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />

      <v-text-field
        prefix="Caudal manual:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.caudal_manual"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.caudal_manual == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />
  
      <!-- -------------------------------------------------------------------------------------------------- -->
    </v-container>
  </template>
  
  <script>
  import { mapState, mapGetters, mapActions } from "vuex";
  
  import KoioteColorPickerVue from "@/components/utils/KoioteColorPicker.vue";
  
  export default {
    name: "KoioteAutomaticValueLabelProperties",
  
    components: {
      KoioteColorPickerVue,
    },
  
    computed: {
      ...mapState(["selectedItem"]),
  
      value() {
        return (
          this.actualPage()
            .global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
            ?.customized?.vartable?.find((v) => v.formatted_address == this.selectedItem.customized.address)?.value || 0
        );
      },
    },
  
    methods: {
      ...mapGetters(["actualPage"]),
      ...mapActions(["updateEditing"]),
  
      change_background_color(nc) {
        this.selectedItem.customized.background_color = nc;
      },
  
      change_foreground_color(nc) {
        this.selectedItem.customized.foreground_color = nc;
      },
  
      change_border_color(nc) {
        this.selectedItem.customized.border_color = nc;
      },
    },
  };
  </script>
  